/*
 * @Description: 动态配置文件
 * @Author: mdb
 * @Date: 2022-09-07 13:43:58
 * @LastEditTime: 2022-09-07 14:02:58
 * @LastEditors: mdb
 */
import { getEnvironment } from '@/utils'

interface Settings {
  signKey: string // 签名key
}

// 生产环境配置
const pro: Settings = {
  /**
   * @type {string}
   * @description 验签加密密钥
   */
  signKey: '5d5abb75-3856-473c-8b56-cc49aa6e3c2h'
}

// 非生产环境配置(包括测试环境、预发布环境、开发环境)
const other: Settings = {
  /**
   * @type {string}
   * @description 验签加密密钥
   */
  signKey: '5d5abb75-3856-473c-8b56-cc49aa6e3c2h'
}

export default (getEnvironment() === 'pro' ? pro : other) as Settings
